// @ts-ignore
// @ts-nocheck
import api from 'services/api';

type ContactsModel = {
  contact: string;
  contactId: string;
  contactIdSf?: string;
  contactType: string;
  isValidated: boolean;
  name: string;
  status: string;
  isNeedUpdate?: boolean;
};

type CustomerAddressesData = {
  addressLine: string;
  addressNumber: string;
  addressType: string;
  city: string;
  code: string;
  complement: string;
  contry: string;
  document: string;
  siteId: string;
  stateCode: string;
  zipCode: string;
  contacts: ContactsModel[];
};

export type UserDataResponse = {
  customerAddresses: CustomerAddressesData[];
};

export const getUserData = async (): Promise<UserDataResponse | undefined> => {
  const token = localStorage.getItem('@UltragazEmpresarial:accessToken');

  const header = {
    'Content-Type': 'application/json',
    access_token: token as string,
  };

  try {
    const res = await api.get('industrial/customer/v1/customers/me', {
      method: 'GET',
      headers: header,
    });
    if (res.data) {
      return res.data;
    }
  } catch (err) {
    console.error(err);
  }
};
